(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jasim-whatsapp"]) return;
  try {
    
  if (!customElements.get('jasim-whatsapp')) {
    customElements.define('jasim-whatsapp', class extends HTMLElement {
      connectedCallback() {
        this.queue = () => {
          if (this.timer) return;
          this.timer = setTimeout(() => { this.timer = 0; this.place(); }, 120);
        };
        this.observer = new MutationObserver(records => {
          if (records.some(r => !this.contains(r.target))) this.queue();
        });
        this.observer.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['class','style','open','hidden','aria-expanded']});
        window.addEventListener('resize', this.queue);
        window.addEventListener('scroll', this.queue, {passive:true});
        this.queue();
      }
      place() {
        this.hidden = false;
        this.style.removeProperty('--wa-lift');
        const box = this.getBoundingClientRect();
        let bottom = box.bottom;
        const blockers = [...document.querySelectorAll('iframe, [id*="chat"], [class*="chat"], [class*="sticky"], [class*="floating"], [id*="cookie"], [class*="cookie"], [data-wa-obstacle], #shopify-pc__banner, [class*="ai-mobile-nav"], [id*="wsp-recent-purchase-popup"], #PBarNextFrameWrapper')].filter(el => {
          if (this.contains(el) || el.contains(this)) return false;
          const css = getComputedStyle(el);
          return (css.position === 'fixed' || css.position === 'sticky') && css.visibility !== 'hidden' && css.display !== 'none' && Number(css.opacity) !== 0;
        }).map(el => el.getBoundingClientRect()).filter(r => r.width && r.height && r.top < innerHeight && r.bottom > 0);
        for (let i = 0; i <= blockers.length; i++) {
          const hit = blockers.find(r => box.left < r.right + 8 && box.right > r.left - 8 && bottom > r.top - 10 && bottom - box.height < r.bottom + 10);
          if (!hit) break;
          bottom = hit.top - 10;
        }
        if (bottom - box.height < 12) { this.hidden = true; return; }
        const safe = parseFloat(getComputedStyle(this).bottom) || 0;
        const base = parseFloat(getComputedStyle(this).getPropertyValue('--wa-bottom')) || 0;
        this.style.setProperty('--wa-lift', `${Math.max(base, innerHeight - bottom - (safe - base))}px`);
      }
      disconnectedCallback() {
        this.observer?.disconnect(); clearTimeout(this.timer);
        window.removeEventListener('resize', this.queue);
        window.removeEventListener('scroll', this.queue);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
